import React, { Component } from "react";
import axios from "axios";
import logo from "./logo.svg";
import "react-virtualized/styles.css";
import { List, AutoSizer } from "react-virtualized";
import CopyToClipboard from "react-copy-to-clipboard";
import Clipboard from "clipboard";

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};
const convertLineBreaks = text => {
    let t = text.replaceAll("<p>", "");
    t = t.replaceAll("</p>", "\n\n");
    t = t.replaceAll("<br />", "\n");
    return t;
};

class Checkbox extends Component {
    render() {
        return (
            <label>
                <input
                    name={this.props.name}
                    type="checkbox"
                    checked={this.props.checked}
                    onChange={this.props.onChange}
                />
                {this.props.label}
            </label>
        );
    }
}

class SearchBar extends Component {
    state = {
        store: "",
        loading: false
    };

    onChange = e => {
        this.setState({ store: e.target.value });
    };

    render() {
        return (
            <div>
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        this.props.search(this.state.store, false);
                    }}
                >
                    <input
                        className="search"
                        type="text"
                        onChange={this.onChange}
                        placeholder="Enter your Store Name or Store URL"
                        value={this.state.store}
                    />
                    <button type="submit">
                        {this.props.status == FETCH_STATUS.REQUESTED
                            ? "..."
                            : "GO"}
                    </button>
                </form>
            </div>
        );
    }
}

class TPTPreview extends Component {
    state = {
        copied: false
    };

    componentDidMount() {
        const button = this.button;
        const input = this.input;
        this.clipboard = new Clipboard(button, {
            target: () => input
        });
    }
    generateHtml = products => {
        if (products.length === 0) {
            return "";
        }
        let text = `<p><strong>Related Products</strong><br />`;
        products.forEach(p => {
            text += ` <span> ⭐ </span> <a href="https://www.teacherspayteachers.com${
                p.url
            }">${p.title}</a><br />`;
        });
        text += "</p>";
        return text;
    };

    onClickNew = () => {
        this.setState({ copied: true });
    };

    componentWillUnmount() {
        this.clipboard.destroy();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.products !== this.props.products) {
            this.setState({ copied: false });
        }
    }

    render() {
        const html = this.generateHtml(this.props.products);
        const { status } = this.props;
        return (
            <div className="six columns">
                <div>
                    <div>
                        <h6 style={{ marginBottom: 0 }}>Preview</h6>
                        <div className="selection half">
                            <div
                                ref={element => {
                                    this.input = element;
                                }}
                                dangerouslySetInnerHTML={{ __html: html }}
                            />
                        </div>
                        <div className="flex">
                            <h6 style={{ marginBottom: 0 }}>HTML Code</h6>
                        </div>
                        <div className="selection half">
                            <div className="html">{html}</div>
                        </div>
                    </div>
                </div>
                <div
                    className="flex"
                    style={{
                        display:
                            status === FETCH_STATUS.SUCCEEDED ? "flex" : "none"
                    }}
                >
                    <CopyToClipboard
                        text={html}
                        onCopy={() => this.setState({ copied: true })}
                    >
                        <button className="button button-primary">Copy</button>
                    </CopyToClipboard>
                    <button
                        style={{ marginLeft: 10 }}
                        className="button button-primary"
                        ref={element => {
                            this.button = element;
                        }}
                        onClick={this.onClickNew}
                    >
                        Copy for New TPT Editor
                    </button>
                </div>
                <div>
                    {this.state.copied &&
                        "Copied to clipboard. You can now paste it into your product description."}
                </div>
            </div>
        );
    }
}

class CreateLinks extends Component {
    state = {
        selectedProducts: []
    };

    toggleSelection = product => e => {
        const { selectedProducts } = this.state;
        const shouldAdd = e.target.checked;
        if (shouldAdd) {
            const temp = [...selectedProducts];
            temp.push({ ...product });
            this.setState({
                selectedProducts: temp
            });
        } else {
            const temp = [...selectedProducts];
            const index = temp.findIndex(p => p.url === product.url);
            temp.splice(index, 1);
            this.setState({ selectedProducts: temp });
        }
    };
    noRowsRenderer = () => {
        return <div>No products found for the store</div>;
    };

    rowRenderer = ({ key, index, style }) => {
        const product = this.props.products[index];
        const checked =
            this.state.selectedProducts.findIndex(s => s.id === product.id) >=
            0;
        return (
            <div style={style} key={key + checked}>
                <Checkbox
                    name={product.id}
                    label={product.title}
                    checked={checked}
                    onChange={this.toggleSelection(product)}
                />
            </div>
        );
    };
    render() {
        const { status } = this.props;
        return (
            <div className="row">
                <div className="six columns">
                    <div className="create">
                        <div className="flex">
                            <h6 style={{ marginBottom: 0 }}>
                                Select your Products
                            </h6>
                            {this.props.products.length > 0 && (
                                <div
                                    className="clickable"
                                    onClick={this.props.refresh}
                                >
                                    Refresh All
                                </div>
                            )}
                        </div>

                        <div className="selection">
                            {status === FETCH_STATUS.REQUESTED && (
                                <div>Loading Store Products</div>
                            )}
                            {status === FETCH_STATUS.FAILED && (
                                <div>
                                    Could not find or load any products for the
                                    store. Are you sure you spelt the store name
                                    correctly?
                                </div>
                            )}
                            {status === FETCH_STATUS.SUCCEEDED && (
                                <AutoSizer>
                                    {({ width, height }) => (
                                        <List
                                            {...this.state}
                                            height={height}
                                            noRowsRenderer={this.noRowsRenderer}
                                            rowCount={
                                                this.props.products.length
                                            }
                                            rowHeight={25}
                                            rowRenderer={this.rowRenderer}
                                            width={width}
                                        />
                                    )}
                                </AutoSizer>
                            )}
                        </div>
                    </div>
                </div>
                <TPTPreview
                    {...this.props}
                    {...this.state}
                    products={this.state.selectedProducts}
                />
            </div>
        );
    }
}

const FETCH_STATUS = {
    REQUESTED: "REQUESTED",
    FAILED: "FAILED",
    SUCCEEDED: "SUCCEEDED",
    NOT_STARTED: "NOT_STARTED"
};

class App extends Component {
    state = {
        status: FETCH_STATUS.NOT_STARTED,
        products: [],
        storeName: ""
    };

    refresh = () => {
        this.search(this.state.storeName, true);
    };

    search = (storeName, refresh) => {
        this.setState({ status: FETCH_STATUS.REQUESTED, storeName: storeName });
        axios
            .get(
                `https://9x3p2gpkxc.execute-api.us-west-1.amazonaws.com/Prod/products?shop=${storeName}&refresh=${refresh}`
            )
            .then(result => {
                const products = result.data;
                products.sort((a, b) => (a.title < b.title ? -1 : 1));

                this.setState({
                    status: FETCH_STATUS.SUCCEEDED,
                    products: result.data
                });
            })
            .catch(e => {
                this.setState({
                    status: FETCH_STATUS.FAILED,
                    products: []
                });
            });
    };
    render() {
        const { status } = this.state;
        return (
            <div className="container">
                <nav className="navbar">
                    <div className="container">
                        <ul className="navbar-list">
                            <li className="navbar-item">
                                <a className="navbar-link" href="/">
                                    &lt; Back to Bearwood Labs
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div style={{ textAlign: "center" }}>
                    <h3 style={{ marginBottom: 0 }}>Product Links Creator</h3>
                    <div style={{ marginTop: 0 }}>
                        <small>For your TPT product descriptions</small>
                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <SearchBar
                        search={this.search}
                        status={this.state.status}
                    />
                    <CreateLinks
                        refresh={this.refresh}
                        status={this.state.status}
                        products={this.state.products}
                    />
                </div>
                <hr />
                <footer>
                    <div style={{ textAlign: "center" }}>
                        <h6>
                            made with ❤️ from <a href="/">Bearwood Labs</a>
                        </h6>
                    </div>
                </footer>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js